import { useMutation, useQueryClient } from 'react-query'

import { IUpdateImpactPeriodDto } from 'src/types'

import { QUERY_KEYS } from 'src/constants'
import { croneJobsService } from 'src/services/crone-jobs.service'
import { IUpdateCronJobDto } from 'src/types/cron-jobs.type'

const useUpdateCronJob = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async ({ id, ...rest }: IUpdateCronJobDto & { id: string }) => {
      return croneJobsService.updateCronJob(id, rest)
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.invalidateQueries(QUERY_KEYS.CRONE_JOBS)
        }
      },
    },
  )
}

export { useUpdateCronJob }
